import styled from "styled-components";

export const PaginationLi = styled.li`
   {
    list-style: none;
  }
`;
